export default "__VITE_ASSET__BuwMjj5f__"